import React from 'react';
import PropTypes from 'prop-types';
import { resolveTestId } from '@cvent/nucleus-test-automation';

/**
* Container component that wraps a group of rows.
*/
const Container = (props, context) => {
  const { children, isFluid, className = '' } = props;
  const { grid } = context;
  return (
    <div
      className={`${className} ${(isFluid ? grid['container-fluid'] : grid.container)}`}
      style={props.style}
      {...resolveTestId(props)}
    >
      {children}
    </div>);
};

Container.propTypes = {
  /** The container's children */
  children: PropTypes.node,
  /** fluid or fixed width container */
  isFluid: PropTypes.bool,
  /** container css class */
  className: PropTypes.string
};
Container.defaultProps = {
  isFluid: false
};
Container.contextTypes = {
  grid: PropTypes.object
};
Container.displayName = 'Container';

export default Container;
